import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { LoginComponent } from "./login.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import {
  ToasterModule,
  ToasterService,
} from "angular2-toaster/angular2-toaster";
import { CommonModule } from "@angular/common";
import { ICMenuService } from "../../services/icmenu.service";
@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    NgxSpinnerModule,
    ButtonsModule.forRoot(),
    TranslateModule,
    ToasterModule,
  ],
  declarations: [LoginComponent],
  providers: [ICMenuService],
})
export class LoginModule {}
